import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import ContactInfo from './ContactInfo/component';
import { IAppState } from '../../../state/reducers';
import { clearAll } from '../../../state/exchange/contactInfoDialog';

class ContactInfoDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
      >
        <ContactInfo />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.contactInfoDialog.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactInfoDialog);
